import _ from 'lodash';
import globalStore from '$$globalStore';
import tasksHelpers from '$$store/tasks/helpers';
import GanttWorker from '../workers/GanttWorker';
import ProgressWorker from '../workers/ProgressWorker';

export default async function (tasks, fromGantt) {
  const tasksMap = globalStore.getters['tasksModel/tasksByIds'];

  const updatedMap = {};
  const deletedTasksForCommit = [];
  const updatedTasksForCommit = [];
  let refreshOverload = false;

  // Tasks delete
  tasks.forEach(task => {
    if (!tasksMap[task.id]) {
      throw new Error('Not found task for removing');
    }

    if (!tasksMap[task.id].parent) {
      return;
    }

    const taskToDelete = tasksMap[task.id];
    const children = tasksHelpers.getAllChildrenOfTasks([taskToDelete]);

    deletedTasksForCommit.push(taskToDelete, ...children);

    if (deletedTasksForCommit.some(t => t.resources?.length)) {
      refreshOverload = true;
    }
  });

  // Run workers (if needed)
  const needGanttWorker = !fromGantt && deletedTasksForCommit.length;
  const needProgressWorker = deletedTasksForCommit.length;
  let ganttWorkerData = null;
  let progressWorkerData = null;

  if (needGanttWorker) {
    ganttWorkerData = await GanttWorker.calculate(deletedTasksForCommit, 'changeTasks', 'removeTasks');
    fromGantt = false;
  }

  if (needProgressWorker) {
    progressWorkerData = await ProgressWorker.calculate(deletedTasksForCommit, 'changeTasks', 'removeTasks');
    fromGantt = false;
  }

  if (ganttWorkerData || progressWorkerData) {
    const combinedData = _.merge(ganttWorkerData?.diff?.tasks, progressWorkerData?.diff?.tasks);

    _.forOwn(combinedData, (diff, taskId) => {
      if (!updatedMap[taskId]) {
        updatedMap[taskId] = diff;
        updatedTasksForCommit.push({ id: +taskId, ...tasksMap[taskId], ...diff });
      }

      if (tasksMap[taskId] && tasksMap[taskId].resources?.length && !refreshOverload) {
        refreshOverload = _.has(diff, 'start_date') || _.has(diff, 'duration');
      }
    });
  }

  return {
    updatedMap, deletedTasksForCommit, updatedTasksForCommit, refreshOverload, fromGantt,
  };
}
